import { IMAGES } from '@/assets/image';
import { cn } from '@/utils';

interface LoaderProps {
  className?: string;
  isAbsolute?: boolean;
  fullScreen?: boolean;
}

const Loader = ({ className, isAbsolute = false, fullScreen = true }: LoaderProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-white/40 text-black',
        fullScreen
          ? 'fixed inset-0 z-[9999] h-screen w-screen'
          : isAbsolute
            ? 'absolute inset-0 z-[9999] h-full w-full'
            : 'h-[200px] w-full',
        className
      )}
    >
      <img src={IMAGES.ICONS_PUBLIC.spinner} alt="Loading" className="size-6 animate-spin" />
    </div>
  );
};

export default Loader;
